<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title" v-t="'message.action_create_layer'">
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <table width=100% height=100% cellpadding=0 cellspacing=0>
                        <tr class="dialoginputfield">
                            <td colspan=2>
                                <el-form label-width="100px" >
                                    <el-form-item prop="groupName" ref="groupName">
                                        <div slot="label" style="text-align:left"><span v-t="'message.item_layerId'"> <span class="required">必須</span></div>
                                        <el-input id="groupName" size="large" type="text" :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.groupName.value"
                                             @compositionstart.native="compositionStart($event.target.id)" @compositionend.native="compositionEnd($event.target.id)" @input.native="inputCheck($event.target.id)"
                                             clearable @clear="InputCheckAll()"/>
                                    </el-form-item>
                                    <el-radio-group style="padding-left:10px" v-model="selectedAclType" fill="#5171cb">
                                        <el-radio-button :label="aclType[1]"></el-radio-button>
                                        <el-radio-button :label="aclType[0]"></el-radio-button>
                                    </el-radio-group>
                                </el-form>
                            </td>
                        </tr>
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title" v-t="'message.common_action_select_user'">
                                    </div>
                                </div>
                                <div class="inner-panel-addgroup">
                                    <dialogtree
                                        v-bind:initialData="appData.tenantList"
                                        @on-selectnode="handleOnSelectNode"
                                        selectionType=1
                                        :showAdminUser="true"
                                        ref="dialogTree">
                                    </dialogtree>
                                </div>
                            </td>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="{ path: 'message.layer_title_acl_ro', args: { name: $t('message.layer_title_param') } }">
                                        </div>
                                        <div class="inner-panel-title-right">
                                            <button class="transparent" @click="removeRoAllUserTag()" type="button"><span class="normal-command-text" v-t="'message.common_action_delete_all'"></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div id="selected-user-ro" class="acl-panel">
                                    <div class="selected-item-field">
                                        <div class="default-message" v-if="(Object.keys(roTagList) == 0) && (selectedAclType == this.aclType[0])" v-html="$t('message.common_action_add_user')">
                                        </div>
                                        <div class="userTag" v-for="tag in roTagList" v-bind:key="tag.aclId">
                                            <span v-if="tag.displayName == null">{{ tag.userName }}</span>
                                            <span v-else>{{ tag.userName + "@" + tag.tenantName + " / " + tag.displayName }}</span>
                                            <span class="closeTag" @click="removeRoUserTag(tag)">×</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="{ path: 'message.layer_title_acl_rw', args: { name: $t('message.layer_title_param') } }">
                                        </div>
                                        <div class="inner-panel-title-right">
                                            <button class="transparent-button" @click="removeRwAllUserTag()" type="button"><span class="normal-command-text" v-t="'message.common_action_delete_all'"></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div  id="selected-user-rw" class="acl-panel">
                                    <div class="selected-item-field">
                                        <div class="default-message" v-if="(Object.keys(rwTagList) == 0) && (selectedAclType == this.aclType[1])" v-html="$t('message.common_action_add_user')">
                                        </div>
                                        <div class="userTag" v-for="tag in rwTagList" v-bind:key="tag.aclId">
                                            <span v-if="tag.displayName == null">{{ tag.userName }}</span>
                                            <span v-else>{{ tag.userName + "@" + tag.tenantName + " / " + tag.displayName }}</span>
                                            <span class="closeTag" @click="removeRwUserTag(tag)">×</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button type="button" class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.disableButton" @click="addGroup()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import DialogTree from "./DialogTree.vue"
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import constants from './constants.js';

export default {
    data() {
        return {
            aclSortWork: {
                roUsers: [],
                rwUsers: [],
            },
            sortedRoUsersCount: 0,
            sortedRwUsersCount: 0,
            inputForm: {
                groupName: { validationRule: "objectId", value: null, isComposing: false },
                acl: {
                    ro: [],
                    rw: []
                },
                valid: [ true ]
            },
            parentNodeInfo: null ,
            parentNodeAcl: null,
            disableButton: true,
            aclType: [
                commonUtil.getMessageText(this.$i18n,"layer_action_add_acl_ro"),
                commonUtil.getMessageText(this.$i18n,"layer_action_add_acl_rw")
            ] ,
            selectedAclType: null,
            rwTagList: {},
            roTagList: {},
        };
    },
    methods: {
        addGroup: function() {
            let savethis = this;

            savethis.inputForm.acl.ro.splice(0,savethis.inputForm.acl.ro.length);
            Object.keys(savethis.roTagList).forEach(function (key) {
                savethis.inputForm.acl.ro.push(savethis.roTagList[key].aclId);
            });
            savethis.inputForm.acl.rw.splice(0,savethis.inputForm.acl.rw.length);
            Object.keys(savethis.rwTagList).forEach(function (key) {
                savethis.inputForm.acl.rw.push(savethis.rwTagList[key].aclId);
            });
            if (this.inputForm.acl.rw.length == 0) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_writable_user_not_found"));
                return;
            }
            savethis.$emit('add', {name: savethis.inputForm.groupName.value, acl: JSON.stringify(savethis.inputForm.acl)});
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            let validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.$refs[eventTargetId].clearValidate();
                this.disableButton = false;
            } else {
                this.$refs[eventTargetId].validateState = "error";
                this.$refs[eventTargetId].validateMessage = validateResult.message;
                this.disableButton = true;
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        InputCheckAll() {
            this.inputCheck("groupName");
        },
        handleOnSelectNode(data,node) {
            if (data.type == 1) {
                let tenantName;
                for (var i = 0 ; i <  this.appData.tenantList.length ; i++) {
                    if (this.appData.tenantList[i].tenantId == data.tenantId) {
                        tenantName = this.appData.tenantList[i].name;
                        break;
                    }
                }
                let key = data.tenantId + '-' + data.id
                if (this.selectedAclType == this.aclType[0]) {
                    if (!(key in this.roTagList)) {
                        if (Object.keys(this.roTagList).length >= constants.LIMIT_EDIT_TAGS) {
                            commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_too_many_tags"));
                            return;
                        }

                        Vue.set(this.roTagList, key, {userName:data.name, tenantName:tenantName, displayName:data.displayName, aclId: key})
                    } else {
                        commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_user_already_added"));
                    }
                } else {
                    if (!(key in this.rwTagList)) {
                        if (Object.keys(this.rwTagList).length >= constants.LIMIT_EDIT_TAGS) {
                            commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_too_many_tags"));
                            return;
                        }

                        Vue.set(this.rwTagList, key, {userName:data.name, tenantName:tenantName, displayName:data.displayName, aclId: key})
                    } else {
                        commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_user_already_added"));
                    }
                }
            }
        },
        removeRoUserTag: function(tag) {
            Vue.delete(this.roTagList, tag.aclId);
        },
        removeRwUserTag: function(tag) {
            Vue.delete(this.rwTagList, tag.aclId);
        },
        removeRoAllUserTag() {
            this.roTagList = {};
        },
        removeRwAllUserTag() {
            this.rwTagList = {};
        }
    },
    components: {
        dialogtree: DialogTree
    },
    updated: function() {
        let objro = document.getElementById("selected-user-ro");
        objro.scrollTop = objro.scrollHeight;
        let objrw = document.getElementById("selected-user-rw");
        objrw.scrollTop = objrw.scrollHeight;
    },
    created: function() {
        this.selectedAclType = this.aclType[1];

        if (this.aclInfo.ro != null) {
            for (let roUser of this.aclInfo.ro) {
                let key = roUser.id;
                Vue.set(this.roTagList, key , {userName: roUser.userName, tenantName:roUser.tenantName, displayName:roUser.displayName , aclId: key});
            }
        }

        if (this.aclInfo.rw != null) {
            for (let rwUser of this.aclInfo.rw) {
                let key = rwUser.id;
                Vue.set(this.rwTagList, key , {userName: rwUser.userName, tenantName:rwUser.tenantName, displayName:rwUser.displayName , aclId: key});
            }
        }

        return;
    },
    props: ['appData','selectedNode','aclInfo']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dialoginputfield {
    height: 60px;
}

.inner-panel-addgroup {
	position:relative;
    height: calc(80vh - 250px);
    margin: 0;
    overflow: auto;
    border-right: solid;
    border-color: #eee;
    border-width: 1px;
}

.acl-panel {
	position:relative;
    height: -webkit-calc(50% - 38px);
    width: 100%;
    margin: 0;
    overflow: auto;
}

.dialog-body >>> .el-form-item {
    display: inline-block;
    color: #000000;
    height: 50px;
    width: 330px;
    padding-top: 10px;
    padding-left: 20px;
    margin-bottom: 10px;
}

.dialog-body >>> .el-radio-button__orig-radio:checked+.el-radio-button__inner {
    width: 255px;
}
.dialog-body >>> .el-radio-button:first-child .el-radio-button__inner {
    width: 255px;
}

</style>
